<template>
  <div class="logo-header">
    <div class="menu">
      <template v-for="(menuitem, index) in items">
        <div :class="'left-menu menuitem' + (index == activeIndex ? ' active' : '')" v-bind:key="index">
          <img :src="menuitem.image" @click="handleSelect(index)">
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: ['activeIndex'],
  methods: {
    handleSelect: function (key) {
      // console.log('handleSelect', key)
      // console.log('current: ', this.activeIndex)
      if (this.activeIndex === key) {
        // console.log('is current, no route')
        return
      }
      this.$router.push(this.items[key].route)
      // switch (Number(key)) {
      //   case 1:
      //     this.$router.push('/')
      //     break
      //   case 2:
      //     console.log('goto history')
      //     this.$router.push('/MongolHistory')
      //     break
      //   case 3:
      //     this.$router.push('/Story')
      //     break
      //   case 4:
      //     this.$router.push('/Poem')
      //     break
      // }
      // this.$emit('selectMenu', Number(key))
    },
    gotoMenu: function (index) {
      // console.log('goto menu ', index)
      this.$router.push({path: '/MongolHistory'})
    }
  },
  data () {
    return {
      items: [
        {
          'image': '//' + this.$mediaHost + '/naranzug/wangzhan_jiegou/naranzug_menu_index.png',
          'route': '/'
        },
        {
          'image': '//' + this.$mediaHost + '/naranzug/wangzhan_jiegou/naranzug_menu_history.png',
          'route': '/history'
        },
        {
          'image': '//' + this.$mediaHost + '/naranzug/wangzhan_jiegou/naranzug_menu_story.png',
          'route': '/story'
        },
        {
          'image': '//' + this.$mediaHost + '/naranzug/wangzhan_jiegou/naranzug_menu_poem.png',
          'route': '/poem'
        }
      ]
    }
  }
}
</script>
<style>
.logo-header {
  position: fixed;
  top: 0;
  height: 88px;
  width: 100%;
  /* background-color: #3f99a3; */
  background-color: #4bb5c1;
  z-index: 999;
}
.menu {
  display: flex;
  height: 88px;
  justify-content: space-between;
}
.logo-header .menuitem {
  width: 80px;
  padding-top: 4px;
}
.menu .active {
  background-color: #3f99a3;
}
.right-menu {
  /* background-color: red; */
  display: block;
}
.left-menu {
  /* background-color: blue; */
  display: block;
}
.logo {
  width: 110px;
  min-width: 110px;
  margin-top: 4px;
  /* background-color: green; */
}
.page-header {
  position: fixed;
  top: 0;
  width: 100%;
  height: 60px;
  font-size: 18px;
  font-weight: 800;
  color: #444444;
  background-color: #3f99a3;
  z-index: 999;
}
#header-logo {
  background: #4bb5c1;
  box-shadow: 0 0 3px #444444;
  height: 70px;
  width: 110px;
  position: relative;
  /* margin-top: 80px; */
  margin: 84px auto 0 auto;
}
#header-logo .border-logo {
    border: 2px solid #2b666e;
    height: 54px;
    position: absolute;
    left: 6px;
    top: 6px;
    width: 94px;
}
.border-logo .background-logo {
    background: #35818a left top repeat url(//naranzug.ip008.com/wp-content/themes/timeturner/images/hatching-button.png);
    height: 50px;
    margin: 2px auto;
    position: relative;
    width: 90px;
}
.border-logo .background-logo .header-logo-img {
    display: block;
    margin: 0 auto;
    max-height: 50px;
    position: relative;
    width: auto;
}
#header-logo .background-pattern {
    background: left top repeat url(//naranzug.ip008.com/wp-content/themes/timeturner/images/pattern-1.png);
    height: 100%;
    width: 100%;
    z-index: 50;
}
.logo-inner-radius {
    background: #4bb5c1;
    height: 4px;
    position: absolute;
    width: 4px;
    z-index: 20;
}
#header-logo .logo-inner-top-left-radius {
    -webkit-border-bottom-right-radius: 4px;
    -moz-border-radius-bottomright: 4px;
    border-bottom-right-radius: 4px;
    top: 10px;
    left: 10px;
}
#header-logo .logo-inner-top-right-radius {
    -webkit-border-bottom-left-radius: 4px;
    -moz-border-radius-bottomleft: 4px;
    border-bottom-left-radius: 4px;
    top: 10px;
    right: 10px;
}
#header-logo .logo-inner-bottom-left-radius {
    -webkit-border-top-right-radius: 4px;
    -moz-border-radius-topright: 4px;
    border-top-right-radius: 4px;
    bottom: 10px;
    left: 10px;
}
#header-logo .logo-inner-bottom-right-radius {
    -webkit-border-top-left-radius: 4px;
    -moz-border-radius-topleft: 4px;
    border-top-left-radius: 4px;
    bottom: 10px;
    right: 10px;
}
.logo-outer-radius {
    background: #4bb5c1;
    height: 4px;
    border-color: #2b666e;
    position: absolute;
    width: 4px;
    z-index: 30;
}
#header-logo .logo-outer-top-left-radius {
    border-bottom: 2px solid #436a55;
    -webkit-border-bottom-right-radius: 4px;
    -moz-border-radius-bottomright: 4px;
    border-bottom-right-radius: 4px;
    border-right: 2px solid #436a55;
    top: 6px;
    left: 6px;
}
#header-logo .logo-outer-top-right-radius {
    border-bottom: 2px solid #436a55;
    -webkit-border-bottom-left-radius: 4px;
    -moz-border-radius-bottomleft: 4px;
    border-bottom-left-radius: 4px;
    border-left: 2px solid #436a55;
    top: 6px;
    right: 6px;
}
#header-logo .logo-outer-bottom-left-radius {
    border-right: 2px solid #436a55;
    border-top: 2px solid #436a55;
    -webkit-border-top-right-radius: 4px;
    -moz-border-radius-topright: 4px;
    border-top-right-radius: 4px;
    bottom: 6px;
    left: 6px;
}
#header-logo .logo-outer-bottom-right-radius {
    border-left: 2px solid #436a55;
    border-top: 2px solid #436a55;
    -webkit-border-top-left-radius: 4px;
    -moz-border-radius-topleft: 4px;
    border-top-left-radius: 4px;
    bottom: 6px;
    right: 6px;
}
.naranzug-menu .el-menu-item {
  padding: 0 0px;
  width: 66px;
}
.naranzug-menu .el-menu-item * {
  vertical-align: top;
}
.naranzug-menu img {
  max-height: 56px;
}
.el-menu--horizontal>.el-menu-item {
    border-bottom: 0;
    /* background-color: #3f99a3; */
    /* color: #303133; */
}
.el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 0;
    /* background-color: #444444 !important; */
    /* color: #303133; */
}
#right-start {
  margin-left: 110px;
}
.bg-purple {
  background: #d3dce6;
}
.el-row {
  height: 60px;
  margin-bottom: 20px;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/templates/sHeader.vue